function waitUntil(condition) {
  return new Promise((resolve) => {
    const interval = setInterval(() => {
      if (condition()) {
        clearInterval(interval);
        resolve();
      }
    }, 100);
  });
}

const btn = document.createElement("div");
btn.className = "CP-recentlyViewedBtn";
btn.textContent = "Recently Viewed";

const isProductPage = window.location.pathname.includes("/products/");

btn.style.top = isProductPage ? "28%" : "50%";
document.body.appendChild(btn);

// Check if there are recently viewed items
const recentlyViewed =
  JSON.parse(localStorage.getItem("cp_IT_recentlyViewed") || "[]").length > 0;

if (!recentlyViewed) {
  btn.style.display = "none";
}

// Create the drawer
const drawer = document.createElement("div");
drawer.className = "CP-recentlyViewedDrawer";

drawer.innerHTML = `
  <div class="CP-header">
    <span>Recently Viewed</span>
    <span class="CP-closeDrawerBtn"><img src="https://cdn.shopify.com/s/files/1/0155/8131/files/cross_icon_new.png?v=1754671887" alt="Close Icon" width="14" height="14"></span>
  </div>
  <div class="CP-items"></div>
`;

btn.addEventListener("click", () => {
   document.querySelector('html').classList.add('CP-rv-open');
  const itemsContainer = drawer.querySelector(".CP-items");
  itemsContainer.innerHTML = "";

  const recent = JSON.parse(localStorage.getItem("cp_IT_recentlyViewed") || "[]");

  recent.forEach((item) => {
    const productData = {
      id: item.id || "", 
      title: item.title,
      type: item.type || "",
      images: item.images || [item.image],
      variants: item.variants || [{ price: parseFloat(item.price.replace(/[^0-9.]/g, "")) * 100 || 0 }],
      url: `/products/${item.slug}`
    };
    const productCard = `
      <div class="CP-drawer-product-card">
        <div class="CP-drawer-product-media" key="${item.slug}">
          <a href="/products/${item.slug}" class="CP-drawer-product-link">
            <div class="CP-drawer-slide">
              <!--<div class="CP-drawer-image-loader">Loading...</div>-->
              <img src="${item.image.replace(/(\.(jpg|jpeg|png|webp))/, '_480x$1')}"/>
            </div>
          </a>
        </div>
        <div class="CP-drawer-product-info">
          <h2><a href="/products/${item.slug}" class="CP-drawer-product-link">${item.title}</a></h2>
          <div class="CP-drawer-price-info"><span class="money" doubly-currency="INR">${item.price}</span></div>
        </div>
        <div class="CP-drawer-action-btn">
          <button class="quick-view" data-product='${JSON.stringify(productData).replace(/'/g, "&#39;")}' data-url="/products/${item.slug}">Quick View</button>
        </div>
      </div>
    `;
    itemsContainer.insertAdjacentHTML("beforeend", productCard);
  });
  drawer.classList.add("open");
overlay.style.display = "block";

});

drawer.querySelector(".CP-closeDrawerBtn").addEventListener("click", () => {
  drawer.classList.remove("open");
overlay.style.display = "none";
   document.querySelector('html').classList.remove('CP-rv-open');

});
const overlay = document.createElement("div");
overlay.className = "drawer-overlay";
overlay.style.cssText = `
  position: fixed;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background: rgba(0,0,0,0.5);
  z-index: 1999;
  display: none;
`;
document.body.appendChild(overlay);
overlay.addEventListener("click", () => {
  drawer.classList.remove("open");
  overlay.style.display = "none";
    document.querySelector('html').classList.remove('CP-rv-open');
});


document.body.appendChild(drawer);
document.addEventListener("click", function (event) {
  const isDrawerOpen = drawer.classList.contains("open");
  const clickedInsideDrawer = drawer.contains(event.target);
  const clickedButton = btn.contains(event.target);

  if (isDrawerOpen && !clickedInsideDrawer && !clickedButton) {
    drawer.classList.remove("open");
  }
});

async function fetchProductBySlug(slug) {
  const url = `${Shopify.routes.root}products/${slug}.js`;

  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!res.ok) {
      window.location.href = `/products/${slug}`;
      return null;
    }

    const product = await res.json();
    return product;
  } catch (error) {
    console.error("Error fetching product:", error);
    return null;
  }
}

waitUntil(() => window.location.pathname.includes("/products/")).then(async () => {
  const href = location.pathname;
  const slug = href.match(/\/products\/([^/?#]+)/)?.[1];

  if (!slug) return;

  const product = await fetchProductBySlug(slug);
  if (!product) return;

  let recent = JSON.parse(localStorage.getItem("cp_IT_recentlyViewed") || "[]");

  recent = recent.filter((item) => item.slug !== slug);

  const productPrice = document
    .querySelector(".price__regular .price-item")
    ?.innerText.replace(/\n/g, "");

  recent.unshift({
    slug,
    title: product.title,
    image: product.images[0],
    price: productPrice || "N/A",
    id: product.id,
    type: product.type,
    images: product.images,
    variants: product.variants,
    url: product.handle
  });

  if (recent.length > 5) recent = recent.slice(0, 5);

  localStorage.setItem("cp_IT_recentlyViewed", JSON.stringify(recent));
  btn.style.display = "inline-block";
});

document.addEventListener("click", (e) => {
  if (e.target.classList.contains("quick-view")) {
    const url = e.target.getAttribute("data-url");
    if (url) {
      window.location.href = url;
    }
    drawer.classList.remove("open");
    overlay.style.display = "none";
  }
});

const style = document.createElement("style");
style.textContent = `
  /*.CP-recentlyViewedBtn {
    position: fixed;
    right: 0;
    background-color: #2b2b2b;
    color: #ffffff;
    padding: 8px 4px;
    writing-mode: sideways-lr;
    text-orientation: mixed;
    font-family: "Montserrat";
    font-size: 10px;
    cursor: pointer;
    border-radius: 4px 0 0 4px;
    z-index: 1000;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
  }
  */
  .CP-recentlyViewedBtn {
    z-index: 998 !important;
    position: fixed;
    right: 14px;
    top: 50%;
    transform: translateY(-50%) rotate(630deg);
    transform-origin: right center;
    background-color: #2b2b2b;
    color: #ffffff;
    padding: 10px 4px;
    font-family: "Montserrat", sans-serif;
    font-size: 10px;
    line-height: 1;
    cursor: pointer;
    border-radius: 4px 0 0 4px;
    z-index: 1000;
    box-shadow: 0 0 5px rgb(0 0 0 / 30%);
    white-space: nowrap;
  }
  .CP-size-guide-btn {
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    inset: auto;
    left: calc(100% - 68px);
    top: 54%;
    background-color: #2b2b2b;
    color: #ffffff;
    padding: 6px 10px;
    cursor: pointer;
    border-radius: 4px 0 0 4px;
    z-index: 998;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
    transform: translateY(-50%) rotate(630deg);
    min-width: 110px;
    text-align: center;
  }



  /**/
  .CP-recentlyViewedDrawer {
    position: fixed;
    top: 0;
    right: 0;
    width: 260px;
    height: 100%;
    background-color: white;
    box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);
    z-index: 2000;
    transform: translateX(100%);
    transition: transform 0.3s ease-in-out;
    overflow-y: auto;
  }

  .CP-recentlyViewedDrawer .CP-header {
    display: flex;
    justify-content: space-between;
    padding: 0 10px;
    width: 100%;
    align-items: center;
    position: sticky;
    top: 0;
    z-index: 10;
    background: #ffffff;
  }

  .CP-recentlyViewedDrawer .CP-header span {
    font-weight: bold;
    color: #000000;
  }

  .CP-recentlyViewedDrawer.open {
    transform: translateX(0);
  }

  .CP-closeDrawerBtn {
    font-size: 28px;
    background: none;
    border: none;
    cursor: pointer;
  }

  .CP-items {
    padding: 10px;
  }

  .CP-drawer-product-media {
    overflow: hidden;
    position: relative;
    width: 100%;
  }

  .CP-drawer-slide {
    min-width: 100%;
    box-sizing: border-box;
    position: relative;
  }

  .CP-drawer-image-loader {
    position: absolute;
    top: 50%;
    left: 40%;
    font-size: 14px;
    color: #000;
  }

  .CP-drawer-slide img {
    width: 100%;
    height: auto;
    display: block;
  }

  .CP-drawer-product-info {
    margin-block: 10px;
    padding: 0 8px;
  }
  .CP-drawer-product-info h2 {
    font-size: 18px;
}

  .CP-drawer-action-btn {
    display: flex;
    justify-content: center;
    padding: 0 8px;
  }

  .CP-drawer-action-btn button {
    background-color: #4b6246;
    color: #ffffff;
    font-family: "Montserrat";
    font-weight: 400;
    font-size: 10px;
    width: 60%;
    border-radius: 4px;
    padding: 8px 10px;
  }

  .CP-drawer-product-card {
    margin-bottom: 20px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
    padding-bottom: 10px;
  }

  .CP-drawer-price-info {
    font-weight: bold;
  }
.CP-drawer-action-btn button.quick-view {
    background: #4B6246;
    border: none;
    padding: 2px 10px;
    color: white;
    font-size: 14px;
    margin-left: 0px;
}


.CP-rv-open .CP-recentlyViewedDrawer{display:block;transform:translateX(0);transition:transform .2s ease-in-out!important}
.CP-recentlyViewedDrawer .CP-drawer-product-info{margin:0!important;padding:4px 8px!important}
.CP-recentlyViewedDrawer .CP-drawer-product-info h2{font-size:13px!important;font-family:Montserrat!important;color:#2b2b2b!important;font-weight:400!important;margin-block:4px!important}
.CP-recentlyViewedDrawer .CP-drawer-product-info .CP-drawer-price-info{color:#4b6246!important;font-family:Montserrat!important;font-weight:600!important;font-size:13px!important}
.CP-recentlyViewedDrawer .CP-drawer-action-btn{height:35px;padding:0 8px!important;justify-content:start!important}
.CP-recentlyViewedDrawer .CP-header{height:50px}
.CP-recentlyViewedDrawer .CP-header .CP-closeDrawerBtn{width:30px;height:30px;display:flex;justify-content:center;align-items:center;background:transparent;border:none;cursor:pointer}
.CP-recentlyViewedDrawer .CP-header .CP-closeDrawerBtn img{width:14px;height:14px}
.CP-recentlyViewedDrawer .CP-drawer-action-btn button.quick-view{margin-right:0!important;padding:6px!important;font-size:9px!important;width:100%!important;letter-spacing:0!important;text-transform:uppercase!important}
.CP-drawer-product-link{display:block;text-decoration:none!important;color:inherit!important}

`;
document.head.appendChild(style);

if (typeof loadQuickViewButtons === "function") {
  document.addEventListener("DOMContentLoaded", loadQuickViewButtons);
}